module.exports = __webpack_public_path__ + "static/gtm_7-a36dc894769502791809cb32248fe56c.png";